export const environment = {
                       production: true, 
                       suppressLog: true, 
                       
                       name : "Brown University",
                       domain : "brown-carchive",
                       env : "prod",
                       dd_clientToken : "pub185c2b5506876532750ba2de9fb47884",
                       dd_applicationId: "8372738f-7c8d-4e53-949b-6e27f693ae3c",
                       cognitoUserPoolId: "us-east-2_wxa6qdpDr",
                       cognitoClientId: "5d6tspakole4vj67uuru40b9b3",
                       
                       apiRoot           : "/api",
                       socketUrl         : "wss://socket.k16.ai",
                       secureCookie      : true,
                       cookieDomain      : "brown-carchive.k16.io",

                       isOPM             : false,
                       opmReference      : null,
                   };